import ContentItemWithResolver from "models/ContentItemWithResolver";
import get from 'lodash/get';

export default class SliderButton extends ContentItemWithResolver {

  get title() {
    return get(this, '_title.value', '');
  }
}
